import React, { useState } from 'react';
import axios from 'axios';

const ScheduleTour = () => {
  const [formData, setFormData] = useState({
    parentName: '',
    email: '',
    phone: '',
    childName: '',
    childAge: '',
    preferredDate: '',
    preferredTime: '',
    message: '',
    website: '' // Honeypot field
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await axios.post('https://ji8nuitvzg.execute-api.us-east-1.amazonaws.com/prod/api/schedule-tour', formData);
      setSubmitMessage('Thank you! Your tour request has been submitted. We will contact you soon to confirm your appointment.');
      setFormData({
        parentName: '',
        email: '',
        phone: '',
        childName: '',
        childAge: '',
        preferredDate: '',
        preferredTime: '',
        message: '',
        website: ''
      });
    } catch (error) {
      setSubmitMessage('Sorry, there was an error submitting your request. Please try again or call us directly.');
    }
    
    setIsSubmitting(false);
  };

  return (
    <div className="schedule-tour">
      <div className="container">
        <h1>Schedule a Tour</h1>
        <p>We'd love to show you around our facility! Please fill out the form below to schedule your visit.</p>
        
        <div className="tour-content">
          <div className="tour-info">
            <h2>What to Expect</h2>
            <ul>
              <li>Meet our experienced teaching staff</li>
              <li>Tour our classrooms and play areas</li>
              <li>Learn about our curriculum and programs</li>
              <li>Discuss enrollment options and requirements</li>
              <li>Ask any questions you may have</li>
            </ul>
            
            <div className="contact-info">
              <h3>Prefer to Call?</h3>
              <p>Phone: 813-752-6446</p>
              <p>Email: info@kidsclubelc.org</p>
            </div>
          </div>
          
          <form className="tour-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="parentName">Parent/Guardian Name *</label>
              <input
                type="text"
                id="parentName"
                name="parentName"
                value={formData.parentName}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="childName">Child's Name</label>
                <input
                  type="text"
                  id="childName"
                  name="childName"
                  value={formData.childName}
                  onChange={handleChange}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="childAge">Child's Age</label>
                <select
                  id="childAge"
                  name="childAge"
                  value={formData.childAge}
                  onChange={handleChange}
                >
                  <option value="">Select Age</option>
                  <option value="infant">Infant (6 weeks - 12 months)</option>
                  <option value="toddler">Toddler (1 - 2 years)</option>
                  <option value="preschool">Preschool (3 - 4 years)</option>
                  <option value="prekindergarten">Pre-K (4 - 5 years)</option>
                </select>
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="preferredDate">Preferred Date</label>
                <input
                  type="date"
                  id="preferredDate"
                  name="preferredDate"
                  value={formData.preferredDate}
                  onChange={handleChange}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="preferredTime">Preferred Time</label>
                <select
                  id="preferredTime"
                  name="preferredTime"
                  value={formData.preferredTime}
                  onChange={handleChange}
                >
                  <option value="">Select Time</option>
                  <option value="morning">Morning (9:00 AM - 12:00 PM)</option>
                  <option value="afternoon">Afternoon (1:00 PM - 4:00 PM)</option>
                </select>
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Additional Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                placeholder="Any specific questions or requests for your visit?"
              ></textarea>
            </div>
            
            {/* Honeypot field - hidden from users, bots will fill it */}
            <input
              type="text"
              name="website"
              value={formData.website}
              onChange={handleChange}
              style={{ display: 'none' }}
              tabIndex="-1"
              autoComplete="off"
            />
            
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Schedule Tour'}
            </button>
            
            {submitMessage && (
              <div className={`submit-message ${submitMessage.includes('Thank you') ? 'success' : 'error'}`}>
                {submitMessage}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ScheduleTour;